var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-row alert",class:['alert-' + _vm.type],attrs:{"role":"alert"}},[_c('div',[(_vm.type === 'danger')?_c('i',{staticClass:"fal fa-exclamation-circle fa-lg ml-2"}):(_vm.type === 'success')?_c('i',{staticClass:"fal fa-check-circle fa-lg"}):_vm._e()]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }